import { ILogMessage } from "../../../shared/services/Logging.service";
import faker from "faker";
import { ELogTypes } from "../../../shared/enums/logging.enums";

const createLog = (): ILogMessage => {
  const logTypeArray = [];
  for (const [propertyKey, propertyValue] of Object.entries(ELogTypes)) {
    logTypeArray.push(propertyValue);
  }

  return {
    message: faker.random.words(20),
    type: faker.random.arrayElement(logTypeArray),
    data: {
      testData: true,
    },
    timestamp: new Date().toDateString(),
  };
};

const getMockLogs = (numberOfLogs: number): Array<ILogMessage> => {
  return Array.from({ length: numberOfLogs }, createLog);
};

export default { createLog, getMockLogs };
